<template>
  <el-container class="review">
    <el-main v-loading="loading"></el-main>
    <template v-if="resume.operable">
      <el-aside width="440px">
        <el-tabs v-model="activeName">
          <el-tab-pane label="审核简历" name="first" class="reviewResume">
            <el-form ref="reviewForm" label-width="80px" :model="reviewForm" :rules="reviewRules">
              <el-form-item label="操作：" prop="jianli_status_id">
                <el-select v-model="reviewForm.jianli_status_id" placeholder="请选择状态">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="时间：" prop="action_time">
                <el-date-picker
                  v-model="reviewForm.action_time"
                  type="datetime"
                  placeholder="选择日期时间"
                  style="width: 100%;"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="备注：" prop="jianli_talk">
                <el-input
                  v-model="reviewForm.jianli_talk"
                  type="textarea"
                  placeholder="说点什么"
                  resize="none"
                  :rows="4"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="review" :loading="reviewLoading">提交</el-button>
                <!-- <el-button @click="history = resume.id">操作历史</el-button> -->
              </el-form-item>
            </el-form>
            <!-- 操作记录 -->
            <div class="historyOperate" v-if="activities.length > 0">
              <div class="historyOperate-title">
                <i class="el-icon-document"></i> 操作历史
              </div>
              <el-timeline class="historyOperate-item">
                <el-scrollbar>
                  <el-timeline-item
                    v-for="(activity, index) in activities"
                    :key="index"
                    color="#fea99b"
                    :timestamp="activity.history_time"
                    placement="top">
                    <el-card>
                      <div>
                        {{ activity.history_action }}{{ activity.hisotry_name  && ` · ${activity.hisotry_name}`  }}
                        <span class="selectTime">
                          <i class="el-icon-time"></i>{{activity.history_atime}}
                        </span>
                      </div>
                      <div class="remark">{{activity.history_talk}}</div>
                    </el-card>
                  </el-timeline-item>
                </el-scrollbar>
              </el-timeline>
            </div>
          </el-tab-pane>
          <el-tab-pane label="补充信息" name="second">
            <el-form ref="infoForm" label-width="100px" :model="infoForm">
              <el-form-item label="姓名：" prop="jianli_name">
                <el-input v-model="infoForm.jianli_name" maxlength="6"></el-input>
              </el-form-item>
              <el-form-item label="手机：" prop="jianli_mobile">
                <el-input v-model="infoForm.jianli_mobile" maxlength="11"></el-input>
              </el-form-item>
              <el-form-item label="年龄：" prop="jianli_age">
                <el-input v-model.number="infoForm.jianli_age" maxlength="2"></el-input>
              </el-form-item>
              <el-form-item label="学历：" prop="jianli_xueli">
                <el-select
                  v-model="infoForm.jianli_xueli"
                  filterable
                  allow-create
                  default-first-option
                  placeholder
                >
                  <el-option
                    v-for="(item, index) in ['专科', '本科', '研究生']"
                    :key="index"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="性别：" prop="jianli_gender">
                <el-radio-group v-model="infoForm.jianli_gender">
                  <el-radio label="男">男</el-radio>
                  <el-radio label="女">女</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="邮箱：" prop="jianli_email">
                <el-input v-model="infoForm.jianli_email"></el-input>
              </el-form-item>
              <el-form-item label="学校：" prop="jianli_xuexiao">
                <el-input v-model="infoForm.jianli_xuexiao" maxlength="16"></el-input>
              </el-form-item>
              <el-form-item label="简历来源：" prop="jianli_laizi">
                <el-input v-model="infoForm.jianli_laizi" maxlength="16"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="submit" :loading="infoLoading">提交</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </el-aside>
      <history-modal v-model="history"></history-modal>
    </template>
  </el-container>
</template>

<script>
import HistoryModal from '@/components/service/history-modal'

export default {
  components: { HistoryModal },
  data () {
    return {
      resume: {
        id: this.$route.params.id,
        operable: this.$route.path.includes('operable') && this.$route.query.active !== '7' // active = 7 为下线职位的入口，不展示简历操作
      },
      loading: true,
      reviewLoading: false,
      infoLoading: false,
      reviewForm: {
        action_time: '',
        jianli_status_id: '',
        jianli_talk: ''
      },
      history: '',
      url: '',
      activeName: 'first',
      options: this.$store.state.global.resume_status_enum,
      reviewRules: {
        jianli_status_id: { required: true, message: '请选择状态', trigger: 'change' }
      },
      infoForm: {
        jianli_name: '',
        jianli_mobile: '',
        jianli_xueli: '',
        jianli_gender: '',
        jianli_xuexiao: '',
        jianli_email: '',
        jianli_age: '',
        jianli_laizi: ''
      },
      infoRules: {
        jianli_name: [
          { required: true, message: '请输入姓名' },
          { min: 2, max: 6, message: '长度在 2 到 6 个字符' }
        ],
        jianli_mobile: { required: true, message: '请输入手机号' },
        jianli_email: [
          { required: true, message: '请输入邮箱' },
          { type: 'email', message: '请输入合法的邮箱' }
        ],
        jianli_gender: { required: true, message: '请选择性别' },
        jianli_xueli: { required: true, message: '请输入学历' },
        jianli_xuexiao: { required: true, message: '请输入学校' },
        jianli_age: [
          { required: true, message: '请输入年龄' },
          { type: 'number', message: '年龄必须为数字' }
        ]
      },
      isLookOver: false, // 是否有权限查看操作历史
      activities: [] // 操作人:hisotry_name, 干了什么:history_action, 备注:history_talk ，操作时间:history_time
    }
  },
  created () {
    const url = `zhaopin/zhiwei/jianli/view?i=${this.resume.id}`
    this.$http.get(url).then(res => {
      if (res.status === 200) {
        const $iframe = document.createElement('iframe')
        const self = this
        this.$el.querySelector('.el-main').appendChild($iframe)
        $iframe.style.display = 'none'
        $iframe.src = `/api/${url}`
        $iframe.onload = function () {
          const $style = document.createElement('style')
          $style.innerText = 'body > *{margin:auto}'
          this.contentDocument.body.appendChild($style)
          this.style.display = 'block'
          self.loading = false
        }
      }
    })
    this.getHistoricalOperation()
  },
  methods: {
    review () {
      this.$refs.reviewForm.validate(valid => {
        if (valid) {
          this.reviewLoading = true
          const form = JSON.parse(JSON.stringify(this.reviewForm))
          form.action_time = this.$root.$options.filters.datetime(form.action_time)
          this.$http.post('/zhaopin/zhiwei/jianli/status2', {
            ...form,
            jianli_id: this.resume.id
          }).then(res => {
            if (res.successful) {
              if (+form.jianli_status_id === -1) {
                setTimeout(() => {
                  window.close()
                }, 500)
              } else {
                this.$refs.reviewForm.resetFields()
              }
              this.reviewLoading = false
              // 重新获取数据进行渲染
              this.getHistoricalOperation()
            }
          })
        }
      })
    },
    submit () {
      this.$refs.infoForm.validate(valid => {
        if (valid) {
          this.infoLoading = true
          this.$http.post('/zhaopin/jianli/detail/change2', {
            ...this.infoForm,
            jianli_id: this.resume.id
          }).then(res => {
            res.successful && this.$refs.infoForm.resetFields()
            this.infoLoading = false
          })
        }
      })
    },
    // 获取历史操作数据
    async getHistoricalOperation() {
      const result = await this.$http.post('zhaopin/zhiwei/detail2', {
        jianli_id: this.resume.id
      })
      if (!result.data) return false
      this.activities = result.data.data || []
    }
  }
}
</script>

<style lang="scss">
.review {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  .el-tabs__header{
    margin: 0;
  }
  .el-tabs__nav-wrap {
    padding-left: 20px;
    &::after {
      height: 1px;
    }
  }
  .el-aside {
    background: #fff;
    border-left: 1px solid #e4e7ed;
  }
  .el-form {
    padding: 30px 24px 0 0;
  }
  .el-main {
    display: flex;
    padding: 0;
  }
  iframe {
    width: 100%;
    height: 100%;
  }
  .reviewResume{
    height: calc(100vh - 40px);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .historyOperate{
      padding: 30px 20px;
      color: #fe725b;
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      &-title{
        margin-bottom: 15px;
        font-size: 14px;
      }
      &-item{
        flex: 1;
        overflow: hidden;
        .el-scrollbar{
          height: 100%;
          .el-scrollbar__view{
           padding: 15px 5px 5px;
           overflow-x:hidden;
          }
          .el-scrollbar__wrap{
            overflow-x:hidden;
          }
        }
      }
      .el-card__body{
        line-height: 1.5;
        .selectTime{
          color: #fea99b;
          i{
            padding: 0 5px;
          }
        }
        .remark{
          color: #a5a7ac;
        }
      }
    }
  }
}
</style>
